<template>
  <div class="d-flex align-center px-2" style="font-size: 13px">
    <span class="pr-5"> Itens por página </span>
    <v-select
      @change="$emit('change', $event)"
      :value="10"
      :items="[10, 20, 30, 50]"
      hide-details
      class="pt-0 mt-0"
      style="max-width: 77px; font-size: 13px"
    />
  </div>
</template>

<script>
export default {};
</script>

<style></style>
